import React from "react"
import { Trans } from "@lingui/react/macro"
import { getPrimaryColor } from "../tokens"

// Bandeau contextuel affiché quand le visiteur consulte la page d'une équipe :
// rappelle le nom de l'équipe courante et propose de revenir à la campagne
// générale (= la racine BASE_WEB_URL, sans le segment d'équipe).
export default function TeamBackBanner({ context, campagneData, campagneTarget }) {

    const teamParam = campagneTarget?.initial?.team
    if (!teamParam) {
        return null
    }

    const team = (campagneData?.teams || []).find(i => i.param === teamParam)
    const teamLabel = team?.label || teamParam

    const primary = getPrimaryColor(campagneData?.config)

    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
                gap: 12,
                padding: "10px 16px",
                background: "rgba(0,0,0,0.04)",
                borderBottom: "1px solid rgba(0,0,0,0.06)",
                fontSize: "0.95rem",
            }}
        >
            <span>
                <Trans>Vous consultez l'équipe</Trans>{" "}
                <strong style={{ textTransform: "capitalize" }}>{teamLabel}</strong>
            </span>

            <a
                href={context.org.BASE_WEB_URL}
                style={{
                    color: primary,
                    fontWeight: 700,
                    textDecoration: "none",
                    whiteSpace: "nowrap",
                }}
            >
                ← <Trans>Revenir à la campagne</Trans>
            </a>
        </div>
    )
}
